/**
 * Created by andrey on 01.02.2021.
 */

const FamilyLayout = cc.Node.extend({
    ctor: function (code, icons, options) {
        options = options || {};
        this.options = options;

        this._super();

        this.code = code;
        this.icons = icons;

        const styles = cleverapps.styles.FamilyLayout;

        const columns = options.resolutionMode === 0 ? 4 : 6;

        this.grid = this.createGrid(icons, options.columns || columns);

        const size = cc.size(options.width || this.grid.width, options.height || this.grid.height);

        const background = this.background = styles.background ? cleverapps.UI.createScale9Sprite(
            bundles.unitslibrarywindow.frames.family_background_png || bundles.windows.frames.windows_details_bg_png,
            cleverapps.UI.Scale9Rect.TwoPixelXY
        ) : new cc.Node();
        background.setAnchorPoint(0.5, 0.5);
        background.setContentSize2(size);
        background.addChild(this.grid);

        this.setContentSize2(background.getContentSize());
        this.setAnchorPoint(0.5, 0.5);

        background.setAlignment(this.width / 2, this.height / 2);
        this.addChild(background);

        this.addProgressBar();

        if (options.title !== false) {
            this.title = this.createTitle(options.title || cleverapps.unitsLibrary.getFamilyName(code));
            this.addChild(this.title);
        }
    },

    decorateIconsWithText: function (icons) {
        const styles = cleverapps.styles.FamilyLayout.grid.iconsDecorators;

        if (styles) {
            return icons.map((icon) => {
                const unit = icon.unit;

                if (!unit.unknown && !cleverapps.skins.getSlot("unitsLibraryMinimalLayout")) {
                    const stageNumber = new cleverapps.UI.ImageFont(
                        icon.unit.stage + 1,
                        cleverapps.styles.FONTS.UNIT_ICON_STAGE_NUMBER
                    );
                    stageNumber.setAlignment(styles.stageNumber);
                    icon.stageNumber = stageNumber;
                    icon.addChild(stageNumber);

                    if (cleverapps.unitsLibrary.isFresh(unit)) {
                        stageNumber.setVisible(false);
                    }
                }

                const font = cleverapps.styles.FONTS.UNIT_ICON_TITLE_TEXT;

                const unitName = cleverapps.UI.generateOnlyText(cleverapps.unitsLibrary.getUnitName(unit), font);
                unitName.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
                unitName.splitInHalf(icon.width);
                unitName.fitTo(icon.width);

                let unitValue;
                if (Families[unit.code].type === "valuables") {
                    const value = Families[unit.code].units[unit.stage].value;
                    if (value > 0) {
                        unitValue = cleverapps.UI.generateOnlyText(`(${value})`, font);
                    }
                }

                return new cleverapps.Layout([icon, unitName, unitValue].filter(Boolean), {
                    direction: cleverapps.UI.VERTICAL,
                    margin: styles.layout.margin
                });
            });
        }

        return icons;
    },

    addProgressBar: function () {
        const styles = cleverapps.styles.FamilyLayout.progress;

        if (!styles || this.options.unknownHero) {
            return;
        }

        const percentage = this.icons.filter((icon) => cleverapps.unitsLibrary.isOpened(icon.unit)).length;
        const progress = new ScaledProgressBar({
            progress: bundles.unitslibrarywindow.frames.family_bar_png,
            background: bundles.unitslibrarywindow.frames.family_bar_bg_png,
            barText: {
                font: cleverapps.styles.FONTS.FAMILY_PROGRESS_FONT
            }
        });
        progress.setLength(styles.width);
        progress.setAlignment(styles);
        progress.setPercentage(percentage);
        progress.setGoal(this.icons.length);
        this.addChild(progress);
    },

    gridSeparator: function () {
        if (cleverapps.config.type !== "merge" || cleverapps.skins.getSlot("unitsLibraryMinimalLayout")) {
            return;
        }

        return {
            horizontal: cleverapps.styles.FamilyLayout.grid.separator
        };
    },

    createGrid: function (icons, columns) {
        const styles = cleverapps.styles.FamilyLayout.grid;

        icons = this.decorateIconsWithText(icons);

        const grid = new cleverapps.GridLayout(icons, {
            columns,
            align: {
                y: cleverapps.GridLayout.ALIGN_END
            },
            padding: styles.padding,
            margin: this.options.margin || styles.margin,
            separator: this.gridSeparator()
        });
        grid.setAlignment(this.options.gridPosition || styles.position);
        return grid;
    },

    createTitle: function (title) {
        const styles = cleverapps.styles.FamilyLayout.title;

        const text = cleverapps.UI.generateOnlyText(title, cleverapps.styles.FONTS.UNITFAMILY_TITLE);
        text.setOpacity(styles.opacity);
        text.setLocalZOrder(2);

        if (bundles.merge.frames.family_title_decor_png) {
            const decor1 = new cc.Sprite(bundles.merge.frames.family_title_decor_png);
            decor1.setLocalZOrder(1);
            decor1.setScaleX(-1);
            const decor2 = new cc.Sprite(bundles.merge.frames.family_title_decor_png);
            decor2.setLocalZOrder(1);

            const layout = new cleverapps.Layout([decor1, text, decor2], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.decorMargin
            });
            layout.setAlignment(styles);
            return layout;
        }

        if (!bundles.windows.frames.family_header) {
            text.setAlignment(styles);
            return text;
        }
        
        const rect = cc.rectAddPadding(cc.rect(0, 0, text.width, text.height), cc.padding(styles.padding));

        const background = cleverapps.UI.createScale9Sprite(bundles.windows.frames.family_header, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(rect.width, background.height);
        background.setAlignment(styles);

        background.addChild(text);
        text.setAlignment(-rect.x + text.width / 2, -rect.y + background.height / 2);

        return background;
    },

    getStyles: function () {
        return cleverapps.styles.FamilyLayout;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    UNITFAMILY_TITLE: {
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    FAMILY_PROGRESS_FONT: {
        name: "default",
        size: 30,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    UNIT_ICON_TITLE_TEXT: {
        size: 25,
        lineHeight: 25,
        color: cleverapps.styles.COLORS.COLOR_LIGHT_TERRACOTTA
    },

    UNIT_ICON_STAGE_NUMBER: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_LIGHT_LIGHT_TERRACOTTA
    }
});

cleverapps.styles.FamilyLayout = {
    background: true,

    title: {
        x: { align: "center" },
        y: { align: "top", dy: 30 },

        padding: {
            x: 55,
            y: 6
        },

        opacity: 255
    },

    grid: {
        position: {
            x: { align: "left" },
            y: { align: "center", dy: -40 }
        },

        padding: {
            x: 50,
            y: 85
        },

        margin: {
            x: 44,
            y: 20
        },

        separator: {
            x: { align: "center" },
            y: { align: "top", dy: -140 }
        }
    }
};